<div class="contenedor">
    <mat-tab-group>
        <mat-tab label="CRM-Tratos">
            <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
            <ng-template matTabContent>
                <div>
                <app-cmfdeals [companyId]="companyId"></app-cmfdeals>
                </div>
            </ng-template>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>